module.exports = __webpack_public_path__ + "static/media/log_14.881efaf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/log_14.jpg
// module id = 1901
// module chunks = 0